module.exports = __webpack_public_path__ + "img/service-m.5127f07f.svg";